import React, { Component } from 'react';

import './BlendArea.css';
import BrickRow from './BrickRow';
class BlendArea extends Component {
  constructor(props) {
    super(props);
    this.brickRows = 15;
    this.bricksPerRow = 6;
    this.bricksToRender = this.brickRows * this.bricksPerRow;
  }
  shouldComponentUpdate(nextProps, nextState) {
  
    if (this.props.bricks !== nextProps.bricks || this.props.accentBrickId !== nextProps.accentBrickId
      || this.props.accentEveryRow !== nextProps.accentEveryRow) {
      return true;     
    }
    return false;
  }
  shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  getRandom = (arr, n) => {
    var result = new Array(n),
      len = arr.length,
      taken = new Array(len);
    if (n > len)
      throw new RangeError("getRandom: more elements taken than available");
    while (n--) {
      var x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
  }

  render() {
    if (this.props.bricks && this.props.bricks.filter((brick) => brick.selected === true).length > 0) {
      let selectedBricks = this.props.bricks.filter((brick) => brick.selected === true);

      let summedRatios = selectedBricks.reduce((a, b) => +a + +b.ratio, 0);

      if (summedRatios !== 100) {
        return (
          <div className={'blendarea bricks'} >
            <div style={{margin:"100px"}}>Ratios must be 100%</div>
          </div>
        );
      } else {


        this.brickArray = [];

        selectedBricks.forEach((selectedBrick, i) => {
          var colorArray = [];

          [...Array(10)].forEach((_, i) => {
            [...Array(this.bricksToRender / 10)].forEach((_, n) => {
              colorArray.push(selectedBrick.images + '/' + (i + 1) + '.png');
            });
          }, this);

          colorArray = this.shuffle(colorArray);

          this.brickArray.push.apply(this.brickArray, this.getRandom(colorArray, Math.round(this.bricksToRender * (selectedBrick.ratio / 100))));

        }, this);

        this.brickArray = this.shuffle(this.brickArray);

        return (
          <div className={'blendarea bricks'} >
            {[...Array(this.brickRows)].map((_, r) => {
              return (
                <BrickRow {...this.props} row={r}  brickRows={this.brickRows}
                bricksPerRow ={this.bricksPerRow}
                bricksToRender={this.bricksToRender}
                brickArray={this.brickArray}
                key={r}
                 />
                
              )
            }, this)}
          </div>
        );
      }

    }
    else {
      return <div className={'blendarea bricks'} ></div>
    }
  }
}

export default BlendArea;
